import styled from 'styled-components';

export const StyledStaleOfflineCleanup = styled('div')`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	pointer-events: none;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/StaleOfflineCleanup/styles.ts